export interface SubscriptionMetadata {
  availableNumberOfStores: number;
  availableNumberOfUsers: number;
}

export enum GelatoPlatformMetadataKeys {
  numberOfStores = 'numberOfStores',
  numberOfUsers = 'numberOfUsers',
}
